export class ContainerStatusConstant {
    static readonly Unpack = { id: 7, name: "Unpack", code: "UPK" };
    static readonly Pack = { id: 11, name: "Pack", code: "PAK" };
    static readonly ReadyForPickup = { id: 8, name: "Ready for pickup", code: "RFP" };
}